import React from 'react';
import { SORT_OPTIONS, SORT_LABELS } from '../../constants/statuses';

const SortDropdown = ({ sortBy, onSortChange }) => {
  const handleChange = (e) => {
    onSortChange(e.target.value);
  };

  return (
    <div className='sort-dropdown'>
      <label htmlFor='booking-sort'>
        <span className='sort-label'>Sort by:</span>
        <select 
          id='booking-sort'
          value={sortBy} 
          onChange={handleChange}
          className='sort-select'
        >
          {Object.entries(SORT_OPTIONS).map(([key, value]) => (
            <option key={value} value={value}>
              {SORT_LABELS[value]}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
};

export default SortDropdown;
